import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
 :root{
    --primary-color: #12A46F;
    --nav-color:#817C8C;
    --text-color:#2D3134;
    --small-text-color:#51515C;
    --bg-color:#F7F7F7;
    --card-bg-color:#F6F6F6;
    --card-bg-green-color:#C6E8DD;
    --title-color:#2D3134;
    --span-color:#8C8D9B;
    --logo-color:#313131;
    --white-color:#FFFFFF;
    --border-color:#E0E0E0;
    --footer-color:#424243;
    --footer-bottom-color:#425466;
    --text-400:#575A5D;
  }
  *{
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
  html{
    font-size: 10px;
    overflow-x: hidden;
  }
  body {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    direction: rtl;
    overflow-x: hidden;
    background-color: var(--bg-color);
    @media (max-width: 480px) {
      background-color: var(--white-color);
    }
  }
  a{
    text-decoration: none;
  }
  ul , li {
    list-style: none;
  }
  /* .container{
    margin: 0 auto;
    max-width: 1400px;
  } */
  /* @media (max-width:1590px) {
   .container{
    padding: 0 20rem;
   }
 }
 @media (max-width:1440px) {
   .container{
    padding: 0 14rem;
   }
 }
 @media (max-width:1350px) {
   .container{
    padding: 0 13rem;
   }
 }
 @media (max-width:1200px) {
   .container{
    padding: 0 10rem;
   }}

   @media (max-width:1024px) {
   .container{
    padding: 0 8rem;
   }}
   @media (max-width:980px) {
   .container{
    padding: 0 7rem;
   }}

   @media (max-width:930px) {
   .container{
    padding: 0 6rem;
   }}
   @media (max-width:870px) {
   .container{
    padding: 0 4rem;
   }}
   @media (max-width:768px) {
   .container{
    padding: 0 3rem;
   }}
   @media (max-width:460px) {
   .container{
    padding: 0 2rem;
   }} */
`;

export default GlobalStyle;
